import React from "react";
import { Paper, Stack, Typography } from "@mui/material";
import { useOutletContext, useParams } from "react-router-dom";
import MCMAItemDetail from "./MCMAItemDetail";
import MFBItemDetail from "./MFBItemDetail";
import MatchItemDetail from "./MatchItemDetail";
import ReArrangeItemDetail from "./ReArrangeItemDetail";
import MarkupItemDetail from "./MarkupItemDetail"; // ✅ Added back here
import RankingItemDetail from "./RankingItemDetail";
import IraabItemDetail from "./IraabItemDetail";

// ✅ Fallback component for unsupported types
const UnsupportedItemDetail = ({ type }) => (
  <Paper
    elevation={1}
    sx={{
      "--Paper-shadow":
        "-3px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.32)",
      p: { xs: 2, md: 3 },
      boxShadow: "var(--Paper-shadow)",
    }}
  >
    <Stack spacing={2}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        Unsupported item type
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {type
          ? `Authoring is not yet available for the “${type}” template.`
          : "Select an item from the library to begin authoring."}
      </Typography>
    </Stack>
  </Paper>
);

// ✅ Main router component
const ItemDetailRouter = () => {
  const context = useOutletContext();
  const { type: typeKeyFromRoute } = useParams();
  const resolvedTypeKey = context?.currentType?.key || typeKeyFromRoute;

  switch (resolvedTypeKey?.toLowerCase()) {
    case "mcma":
      return <MCMAItemDetail />;
    case "match":
      return <MatchItemDetail />;
    case "mfb":
      return <MFBItemDetail />;
    case "arrange":
    case "rearrange":
      return <ReArrangeItemDetail />;
    case "markup":
      return <MarkupItemDetail />; // ✅ Added this line
    case "ranking":
      return <RankingItemDetail />; // ✅ Added this line
    case "iraab":
      return <IraabItemDetail />; // ✅ Added this line
    default:
      return <UnsupportedItemDetail type={resolvedTypeKey} />;
  }
};

export default ItemDetailRouter;
